


































































































































import Vue from 'vue';
export default Vue.extend({
  name: 'DocumentLibraryDetails',
  data() {
    return {
      documentList: {
        'REEVALUATION APRIL 2026': [
          {
            header: 'Reevaluation',
            items: [
              {
                title: 'NEPA Re‑Evaluation Report',
                uploadDate: 'April 2026',
                file:
                  'https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/Approved_Reevaluation2.pdf',
              },
            ],
          },
        ],
        'REEVALUATION MARCH 2025': [
          {
            header: 'Reevaluation',
            items: [
              {
                title: 'NEPA Re‑Evaluation Report',
                uploadDate: 'March 2025',
                file: '2025_0311_nepa re eval w stamp and signature.pdf',
              },
            ],
          },
          {
            header: 'Westlake Stakeholder Meeting',
            items: [
              {
                title: 'Westlake Meeting Presentation',
                uploadDate: 'November 2024',
                file: '2024_0930_Westlake Stakeholder_Presentation_final.pdf',
              },
              {
                title: 'Westlake Meeting Script',
                uploadDate: 'November 2024',
                file: 'Westlake Stakeholder Meeting Presentation Script.pdf',
              },
            ],
          },
          {
            header: 'Stakeholder meeting video',
            items: [
              {
                title: 'Stakeholder meeting video',
                uploadDate: 'September 2024',
                file: 'https://www.youtube.com/watch?v=5DpWc6JI8uQ',
              },
            ],
          },
        ],
        'FINAL EIS SEPTEMBER 2023 / ROD JANUARY 2024': [
          {
            header: 'I-10 Calcasieu River Bridge Final EIS and Record of Decision',
            items: [
              {
                title: 'I-10 Calcasieu River Bridge Final EIS',
                uploadDate: 'September 2023',
                file: 'H.003931+FEIS+09112023.pdf',
              },
              {
                title: 'I-10 Calcasieu River Bridge Final EIS Appendices',
                uploadDate: 'September 2023',
                file: 'H003931_FEIS_Appendices.pdf',
              },
              {
                title: 'I-10 Calcasieu River Bridge Record of Decision',
                uploadDate: 'January 2024',
                file: 'H.003931 ROD_2024_0130 Complete.pdf',
              },
            ],
          },
        ],
        'DRAFT EIS OCTOBER 2022': [
          {
            header: 'I-10 Calcasieu River Bridge Draft EIS',
            items: [
              {
                title: 'I-10 Calcasieu River Bridge Draft EIS',
                uploadDate: 'October 2022',
                file: 'I-10 Calcasieu River Bridge Draft EIS.pdf',
              },
              {
                title: 'Appendix A - Purpose and Need Technical Memorandum',
                uploadDate: 'November 2017',
                file: 'Appendices/A Purpose and Need Tech Memo.pdf',
              },
              {
                title: 'Appendix B - Traffic Engineering Report',
                uploadDate: 'May 2022',
                file: 'Appendices/B Traffic_Engineering_Report.pdf',
              },
              {
                title: 'Appendix C - Public and Agency Meetings',
                uploadDate: '2013 - 2021',
                file: 'Appendices/Appendix C Public and Agency Meetings.pdf',
              },
              {
                title: 'Appendix D - Environmental Justice Technical Memorandum',
                uploadDate: 'October 2022',
                file: 'Appendices/Appendix D Environmental Justice Technical Memorandum.pdf',
              },
              {
                title: 'Appendix E - Section 106 Documentation ',
                uploadDate: 'October 2022',
                file: 'Appendices/Appendix E Section 106 Documentation.pdf',
              },
              {
                title: 'Appendix F - Preliminary Financial Feasibility ',
                uploadDate: 'April 2021',
                file: 'Appendices/F Financial Feasibility.pdf',
              },
              {
                title: 'Appendix G - Agency Correspondence',
                uploadDate: '2013-2021',
                file: 'Appendices/Appendix G Agency Correspondence.pdf',
              },
              {
                title: 'Appendix H - Design Engineering Documents',
                uploadDate: 'October 2022',
                file: 'Appendices/H+Engineering+Documents_10-10-23.pdf',
              },
              {
                title: 'Appendix I - Right of Way and Relocation Assistance Brochure',
                uploadDate: 'May 2019',
                file: 'Appendices/I Right of Way Brochure.pdf',
              },
              {
                title: 'Appendix J - Air Quality Analysis ',
                uploadDate: 'October 2021',
                file: 'Appendices/J Air Quality Report_10292021.pdf',
              },
              {
                title: 'Appendix K - Traffic Noise Technical Analysis',
                uploadDate: 'July 2022',
                file: 'Appendices/Appendix K Traffic Noise Technical Report.pdf',
              },
              {
                title: 'Appendix L - Wetlands and Habitat ',
                uploadDate: 'May 2021',
                file: 'Appendices/Appendix L Wetlands and Habitats.pdf',
              },
              {
                title: 'Appendix M - Phase I Environmental Site Assessment',
                uploadDate: 'August 2021',
                file: 'Appendices/M Phase I ESA.pdf',
              },
              {
                title: 'Appendix N - Section 4(f)',
                uploadDate: 'October 2022',
                file: 'Appendices/N Section 4f Statements.pdf',
              },
              {
                title: 'Appendix O - EDC & VC Plume Drawings ',
                uploadDate: '2020 - 2021',
                file: 'Appendices/O EDC VC Plumes.pdf',
              },
              {
                title: 'Appendix P - Navigation Data Reports ',
                uploadDate: '2007-2022',
                file: 'Appendices/P Navigation Data and Reports.pdf',
              },
              {
                title: 'Appendix Q - Project Coordination and Public Involvement Plans',
                uploadDate: '2018',
                file: 'Appendices/Q PCP and PIP Updates.pdf',
              },
            ],
          },
          {
            header: 'Project Documents',
            items: [
              {
                title:
                  'I-10 Calcasieu River Bridge and Approaches Comprehensive Preliminary Alternatives Report',
                uploadDate: 'May 2002',
                file: '08_Comprehensive_Prelim_Alt_Report_2002.pdf',
              },
              {
                title: 'Bridge Height Special Study',
                uploadDate: 'October 2007',
                file: 'BridgeHeightStudy2007.pdf',
              },
              {
                title: 'Navigational Study for the I-10 Calcasieu River Bridge and Approaches',
                uploadDate: 'September 2014',
                file: '2014 Navigation Study.pdf',
              },
              {
                title: 'Objectives Screening Matrix',
                uploadDate: 'August 2017',
                file: 'Objectives Screening Matrix.pdf',
              },
              {
                title: 'Preliminary Alternatives Screening Methodologies',
                uploadDate: 'August 2017',
                file: 'Preliminary Alternatives Screening Methodologies.pdf',
              },
              {
                title: 'Alternative Screening Methodology Agency Comments & Responses',
                uploadDate: 'September 2017',
                file: 'Alternatives Screening Methodology.pdf',
              },
              {
                title: 'Purpose and Need Technical Memorandum',
                uploadDate: 'November 2017',
                file: 'Purpose and Needs.pdf',
              },
              {
                title: 'Project Coordination Plan',
                uploadDate: 'December 2018',
                file: 'Project Coordination Plan.pdf',
              },
              {
                title: 'LADOTD Acquisition of Right-of-Way and Relocation Assistance Brochure',
                uploadDate: 'May 2019',
                file: '2019+Acquistion+Brochure+revised_v2.pdf',
              },
            ],
          },
          {
            header: 'Public/Agency Meeting Materials',
            items: [
              {
                title: 'Public Involvement Summary – NOI, SOV, and Public Scoping Meeting ',
                uploadDate: 'February 2014',
                file:
                  'H.003931_I-10_Calcasieu_EIS_Final_Public_Scoping_Meeting_Summary_Report-web.pdf',
              },
              {
                title: 'Agency & Public Meeting 1 Comments & Responses',
                uploadDate: 'August 2017',
                file: 'Public and Agency Meeting Comments and Responses.pdf',
              },
              {
                title:
                  "Public Involvement Summary Report: Elected Official's Meeting, Alternative Screening Methodology,  Agency Meeting 2, and Public Meeting 2",
                uploadDate: 'September 2017',
                file: 'Summary Report.pdf',
              },
              {
                title: 'Public Involvement Plan',
                uploadDate: 'December 2018',
                file: 'Public Involvement Plan.pdf',
              },
              {
                title:
                  'Public Involvement Summary Report: Elected Official / Agency Briefing and Public Meeting #3',
                uploadDate: 'April 2019',
                file: 'Public Involvement Summary Report.pdf',
              },
              {
                title:
                  'Public Involvement Summary Report Elected Officials / Agency Briefing Public Meeting #4 and Other Outreach',
                uploadDate: 'March 2021',
                file: 'H003931_Calcasieu_PM4_Summary Report.pdf',
              },
              {
                title: 'Public Meeting #4 Comments and Responses',
                uploadDate: 'May 2021',
                file: 'Comment_Responses_Attachment_I.pdf',
              },
              {
                title: 'Context Sensitive Solutions and Design (CSS/D) Meeting #1 Summary Report',
                uploadDate: 'February 2021',
                file: 'CSSD_Workshop1_Summary_Rev+01.pdf',
              },
              {
                title: 'Context Sensitive Solutions and Design (CSS/D) Meeting #2 Summary Report',
                uploadDate: 'June 2021',
                file: 'CSS_Mtg2_Calcasieu.pdf',
              },
            ],
          },
        ],
      },
      activePanels: [] as number[],
      suppressHashChange: false,
      panelObserver: null as MutationObserver | null,
    };
  },
  computed: {
    sectionKeys(): string[] {
      return Object.keys(this.documentList || {});
    },
    toggleLabel(): string {
      return this.activePanels && this.activePanels.length > 0 ? 'Collapse all' : 'Expand all';
    },
  },
  methods: {
    link(fileName: string) {
      if (!fileName) return '';
      // If the file is an absolute URL (http/https), return it directly.
      if (/^https?:\/\//i.test(fileName)) return fileName;
      const formattedFileName = fileName.replace(/ /g, '+');
      return `https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/${formattedFileName}`;
    },
    slugify(text: string) {
      return String(text)
        .toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
    },
    onChipClick(key: string, idx: number) {
      const slug = this.slugify(key);
      // close other panels and open the target
      this.activePanels = [idx];

      // update URL hash without invoking router navigation
      const base = window.location.href.split('#')[0];
      window.history.replaceState(null, '', `${base}#${slug}`);

      // scroll to the header (now suffixed with -header) accounting for app bar offset
      this.$nextTick(() => {
        const appBarOffset = 125;
        const el = document.getElementById(slug + '-header');
        if (el) {
          const top = el.getBoundingClientRect().top + window.pageYOffset - appBarOffset;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          // focus for accessibility
          (el as HTMLElement).focus();
        }
      });
    },
    // When panels change, update the hash to reflect state.
    // - If no panels open: clear the hash.
    // - If exactly one panel open: set the hash to that panel's slug.
    // - If multiple panels open: clear the hash (don't force a single panel via route).
    onPanelsChange(val: number[] | number) {
      if (this.suppressHashChange) return;
      const active = Array.isArray(val)
        ? val.slice()
        : val === undefined || val === null
        ? []
        : [val];

      if (!active || active.length === 0) {
        // clear hash when no panels are open
        this.$router.replace({ hash: '' }).catch(() => null);
        return;
      }

      if (active.length === 1) {
        const idx = active[0];
        const key = this.sectionKeys[idx];
        if (key) {
          const slug = this.slugify(key);
          // Update URL hash without triggering Vue Router navigation/scrollBehavior
          const base = window.location.href.split('#')[0];
          window.history.replaceState(null, '', `${base}#${slug}`);
        }
        return;
      }

      // Multiple panels open -> clear hash without triggering scroll/navigation
      const baseClear = window.location.href.split('#')[0];
      window.history.replaceState(null, '', baseClear);
    },
    // If `initial` is true (first mount), open default when no hash is present.
    // When called on route changes (initial=false), only react when a hash exists.
    setActiveFromRoute(initial = false) {
      const hash = this.$route && this.$route.hash ? String(this.$route.hash).replace('#', '') : '';
      let idx = -1;
      if (hash) {
        idx = this.sectionKeys.findIndex((k) => this.slugify(k) === hash);
      }
      if (idx >= 0) {
        this.activePanels = [idx];
        // ensure the header is focused for keyboard/screen readers
        this.$nextTick(() => {
          const el = document.getElementById(hash + '-header');
          if (el) (el as HTMLElement).focus();
        });
      } else if (initial) {
        // only open default on the very first mount when there's no hash
        const reeIdx = this.sectionKeys.findIndex((k) =>
          this.slugify(k).startsWith('reevaluation')
        );
        this.activePanels = reeIdx >= 0 ? [reeIdx] : [0];
      }
    },
    togglePanels() {
      // If any panels open -> collapse all. If none open -> expand all.
      if (this.activePanels && this.activePanels.length > 0) {
        this.activePanels = [];
        // clear hash when collapsed
        this.$router.replace({ hash: '' }).catch(() => null);
      } else {
        // open all panel indices without triggering the usual hash-update flow
        this.suppressHashChange = true;
        this.activePanels = this.sectionKeys.map((_, i) => i);
        // clear the suppress flag on next tick so user-driven changes still update the hash
        this.$nextTick(() => {
          this.suppressHashChange = false;
        });
      }
    },
    // Remove aria-expanded from the expansion panel container wrappers (Vuetify sometimes
    // applies aria-expanded to the wrapper which triggers scanner warnings). The header
    // itself carries the correct aria-expanded state now.
    cleanupPanelContainerAria() {
      try {
        const root = this.$el as HTMLElement | null;
        if (!root) return;
        const panels = Array.from(root.querySelectorAll('.v-expansion-panel')) as Element[];
        for (const p of panels) {
          try {
            if (p.hasAttribute && p.hasAttribute('aria-expanded'))
              p.removeAttribute('aria-expanded');
          } catch (err) {
            void 0;
          }
        }
      } catch (err) {
        // ignore
      }
    },
    // Ensure aria-expanded is removed whenever Vuetify re-applies it.
    setupPanelObserver() {
      try {
        const root = this.$el as HTMLElement | null;
        if (!root) return;
        // If we already created an observer, disconnect it first
        if (this.panelObserver) {
          try {
            this.panelObserver.disconnect();
          } catch (e) {
            // ignore
          }
          this.panelObserver = null;
        }

        const cb: MutationCallback = (mutations) => {
          for (const m of mutations) {
            try {
              if (m.type === 'attributes') {
                const target = m.target as Element;
                if (target && target.hasAttribute && target.hasAttribute('aria-expanded')) {
                  target.removeAttribute('aria-expanded');
                }
              }
              if (m.type === 'childList' && m.addedNodes && m.addedNodes.length) {
                for (const n of Array.from(m.addedNodes)) {
                  try {
                    const el = n as Element;
                    if (!el) continue;
                    if (el.classList && el.classList.contains('v-expansion-panel')) {
                      if (el.hasAttribute('aria-expanded')) el.removeAttribute('aria-expanded');
                    }
                    // also remove from any descendants
                    const panels = Array.from(
                      (el.querySelectorAll && el.querySelectorAll('.v-expansion-panel')) || []
                    );
                    for (const p of panels) {
                      try {
                        if (p.hasAttribute && p.hasAttribute('aria-expanded'))
                          p.removeAttribute('aria-expanded');
                      } catch (e) {
                        void 0;
                      }
                    }
                  } catch (e) {
                    void 0;
                  }
                }
              }
            } catch (e) {
              void 0;
            }
          }
        };

        const observer = new MutationObserver(cb);
        observer.observe(root, {
          subtree: true,
          childList: true,
          attributes: true,
          attributeFilter: ['aria-expanded'],
        });
        this.panelObserver = observer;
      } catch (err) {
        // ignore
      }
    },
  },
  mounted() {
    this.setActiveFromRoute(true);
    // remove undesirable aria-expanded on wrappers now and whenever panels change
    this.cleanupPanelContainerAria();
    // observe and remove any aria-expanded attributes Vuetify may reapply
    this.setupPanelObserver();
    this.$watch('$route', () => this.setActiveFromRoute(false));
    this.$watch(
      () => this.activePanels,
      () => {
        this.$nextTick(() => this.cleanupPanelContainerAria());
      },
      { deep: true }
    );
  },
});
